export const ERROR_TOOL_TIP = {
  TOOLTIP: 'errorTooltip'
} as const;
